import { forwardRef, useCallback } from 'react';
import { css } from 'styled-components';

import { filterFilesByType } from 'hb-react/shared/components/DesignSystem/QuillEditor/utils/filterFilesByType';

interface InputFileHiddenProps {
  accept?: Array<string>;
  dataTestId: string;
  multiple?: boolean;
  onChange: (files?: Array<File>) => Promise<void> | void;
}

const InputFileHidden = forwardRef<HTMLInputElement, InputFileHiddenProps>(
  ({ accept, onChange, multiple, dataTestId }, ref) => {
    const handleChange = useCallback(
      (e) => {
        const files = filterFilesByType({
          files: e.target.files,
          types: accept,
        });

        onChange(files);
      },
      [accept, onChange],
    );

    return (
      <input
        aria-hidden
        hidden
        tabIndex={-1}
        ref={ref}
        multiple={multiple}
        accept={accept ? accept.join(',') : undefined}
        onChange={handleChange}
        type="file"
        data-testid={dataTestId}
        // eslint-disable-next-line react/no-unknown-property
        css={css`
          height: 0;
          opacity: 0;
          position: absolute;
          width: 0;
        `}
      />
    );
  },
);

export default InputFileHidden;
